import { Text, VStack, Icon } from "@repo/ui";
import { useTheme } from "@repo/tokens";
import { useTranslation } from "react-i18next";
import { TestModal } from "../TestModal";
import styles from "./UploadResultPopup.module.scss";

type UploadSuccessPopupProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const UploadSuccessPopup = ({
  isOpen,
  onClose,
}: UploadSuccessPopupProps) => {
  const { theme } = useTheme();
  const { t } = useTranslation("tests");

  return (
    <TestModal
      isOpen={isOpen}
      onClose={onClose}
      isOverlay={true}
      width="min(95vw, 40rem)"
      body={
        <VStack className={styles.body}>
          <VStack alignItems="center" className={styles.content}>
            <Icon
              name="checkCircleIcon"
              size={48}
              color={theme.colors.success[60]}
            />

            <Text className={styles.title}>
              {t("upload_answer_sheet_flow.success_title")}
            </Text>

            <Text
              variant="body"
              size="large"
              color={theme.colors.neutral[20]}
              align="center"
              className={styles.successText}
            >
              {t("upload_answer_sheet_flow.success_message")}
            </Text>
            <Text
              variant="body"
              size="medium"
              style={{ fontWeight: 600 }}
              color={theme.colors.neutral[20]}
              className={styles.reportText}
            >
              {t("upload_answer_sheet_flow.success_eta")}
            </Text>
          </VStack>
        </VStack>
      }
    />
  );
};
